import { connect } from 'react-redux'
import { get, map, intersection, flatten, nth, isEmpty } from 'lodash'

import CartItemDetailsModal from '../components/CartItemDetailsModal'

import {
  removeFromCart,
  safelyIncrementCartItemQuantity,
  safelyDecrementCartItemQuantity,
  updateCartItemModifiers,
  safelyUpdateCartItemNotes,
  updateCartItemQuantity,
  updateOpenPriceItem,
} from '../actions/cart'
import { getCartLineItems } from '../selectors/cart'
import { getPOSItemsForCurrentMenu } from '../selectors/items'
import { getIsKeyboardActive } from '../VNAndroidSDK/Selectors'
import { centsToDollars, centsToFloat } from '../utils/formatters'

// TODO: use VNItemDetail instead of CartItemDetailsModal
const mapStateToProps = (state, ownProps) => {
  const cartItemIndex = get(ownProps, 'match.params.cartItemIndex', -1)
  const cartItem = nth(getCartLineItems(state), cartItemIndex) || {}
  const item = get(getPOSItemsForCurrentMenu(state), ['byId', get(cartItem, 'itemId', '')], {})
  const modifierGroups = get(item, 'modifierGroups', [])
  let selectedModifiers = get(cartItem, 'modifiers', [])
  const isKeyboardActive = getIsKeyboardActive(state)

  const modifierGroupsSelections = map(modifierGroups, (modifierGroup) =>
    intersection(
      map(get(modifierGroup, 'items'), (item) => `${item.id}|${modifierGroup.uuid}`),
      flatten(selectedModifiers),
    ),
  )
  const notesAreEmpty = isEmpty(cartItem.notes)
  const cartItemNotValidIfClosed = ownProps?.history.location?.state?.cartItemNotValidIfClosed ?? false
  const isOpenPriceItem = !!cartItem?.openName
  const hasCustomPrice = !!cartItem?.openPriceInCents || cartItem?.openPriceInCents === 0
  const price = hasCustomPrice ? centsToFloat(cartItem?.openPriceInCents) : centsToDollars(item?.defaultPriceInCents)

  return {
    modifierGroups,
    id: item.id,
    isOpenPriceItem: isOpenPriceItem,
    title: item.name,
    customTitle: cartItem?.openName,
    price: price,
    customPriceInCents: cartItem?.openPriceInCents,
    defaultPriceInCents: item?.defaultPriceInCents,
    quantity: cartItem.quantity,
    canEnterNotes: item.canEnterNotes,
    notesAreEmpty,
    notes: cartItem.notes,
    selectedItemIds: modifierGroupsSelections,
    orderMaxAmount: item?.orderMaxAmount ?? 999,
    orderMinCount: item?.orderMinCount ?? 1,
    cartItemNotValidIfClosed,
    isKeyboardActive,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const goBack = get(ownProps, 'history.goBack', () => {})
  const cartItemIndex = get(ownProps, 'match.params.cartItemIndex', -1)

  return {
    dispatch,
    onClose: (isValid) => {
      goBack()

      if (!isValid) {
        dispatch(removeFromCart({ index: cartItemIndex }))
      }
    },
    incrementQuantity: () => {
      dispatch(safelyIncrementCartItemQuantity({ index: cartItemIndex }))
    },
    decrementQuantity: () => {
      dispatch(safelyDecrementCartItemQuantity({ index: cartItemIndex }))
    },
    updateCartItemQuantity: (quantity) => {
      dispatch(updateCartItemQuantity({ index: cartItemIndex, quantity }))
    },
    updateModifiers: (modifiers) => {
      dispatch(updateCartItemModifiers({ index: cartItemIndex, modifiers }))
    },
    updateNotes: (notes) => {
      dispatch(safelyUpdateCartItemNotes({ index: cartItemIndex, notes }))
    },
    updateOpenPriceItem: (openPriceInCents, originalPriceInCents, openName, managerId) => {
      dispatch(updateOpenPriceItem({ index: cartItemIndex, openPriceInCents, originalPriceInCents, openName, managerId }))
    },
    onRemove: () => {
      goBack()

      dispatch(removeFromCart({ index: cartItemIndex }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartItemDetailsModal)
